module.exports = __webpack_public_path__ + "static/media/team-introduction-7.8fbafa7f.jpg";